module.exports = "/wwwroot/img/sorting_station_lift_block.png?ver=23cef4f6";